import React from 'react';
import '@/pages/ventures/Venture.scss';
import aviation from '@/assets/aviation.jpeg';
import PageBanner from '@/components/ui/PageBanner';
import BodyMotion from '@/components/ui/BodyMotion';
import ImageBanner from '@/components/sections/ImageBanner';
import one from '@/assets/aviation/1.jpeg';
import two from '@/assets/aviation/2.jpeg';
import three from '@/assets/aviation/3.jpeg';

const Aviation: React.FC = () => {
  return (
    <main className="venture-page">
      <PageBanner title="Global Aviation" image={aviation} />
      <section className="venture-page__content">
        <BodyMotion>
          <p>
            Few activities define the experience economy like air travel. The impulse to move,
            connect, and explore endures through pandemics, recessions and other global disruptions.
            Aviation forms the essential connective tissue. As global disposable incomes rise and
            new middle classes emerge, demand for flight exhibits long-term structural growth
            characteristics. Meanwhile, the degree to which aircraft supply is structurally
            constrained is material.
          </p>
        </BodyMotion>
      </section>
      <ImageBanner image={one} />
      <section className="venture-page__content">
        <BodyMotion>
          <p>
            The pandemic scrambled deeply complex aviation supply chains built over decades,
            precipitating a multi year aircraft production shortfall. Technological challenges with the latest generation of engines have deepened the supply constraints further, grounding hundreds of aircraft at any given time. Critically, aviation retains a natural protective moat. While technology is transforming how aviation assets are financed and traded, there remains no substitute for air travel.
          </p>
        </BodyMotion>
      </section>
      <ImageBanner image={two} />
      <section className="venture-page__content">
        <BodyMotion>
          <p>
           Our principal's expertise is grounded in the aviation leasing sector, where the most durable economics in the industry reside. Our principal spent over two decades at the leading global aircraft leasing franchise, executing the largest transactions in industry history as the balance sheet scaled from $4bn to over $70bn. That knowledge informs how we evaluate opportunities, structure exposure, and assess risk, and positions Ephemera to work alongside partners and counterparties for whom deep sector fluency has tangible value, should the right opportunities arise.
          </p>
        </BodyMotion>
      </section>
      <ImageBanner image={three} />
      <section className="venture-page__content">
        <BodyMotion>
          <p>
           Ephemera’s aviation exposure is not incidental to its real estate activity. The aircraft that connects a traveller to Lisbon or Amsterdam is as much a part of the experience infrastructure as the property that receives them. We invest in both ends of that journey.
          </p>
        </BodyMotion>
      </section> 
    </main>
  );
};

export default Aviation;
